const TextField = ({ item }) => {
    return (<>
      {item.content?.trim() ?
        <div className="">
          <p className='text text-black' style={{ whiteSpace: "pre-line" }}>{item.content}</p>
        </div> : <></>}
      </>
    )
  }
  
  export default TextField